import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export interface StepIndicatorProps {
  number: number;
  label: string;
  icon: React.ReactNode;
  active: boolean;
  complete: boolean;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ number, label, icon, active, complete }) => (
  <div className={`flex items-center gap-2 ${active ? 'text-primary font-medium' : 'text-muted-foreground'}`}>
    <div
      className={`
        flex items-center justify-center h-6 w-6 rounded-full text-xs font-medium
        ${complete ? 'bg-primary text-primary-foreground' : active ? 'bg-primary/10 text-primary border border-primary' : 'bg-muted text-muted-foreground'}
      `}
      aria-label={`Step ${number}`}
    >
      {complete ? <CheckCircle2 className="h-3.5 w-3.5" /> : icon}
    </div>
    <span className="text-sm">{label}</span>
  </div>
);

export interface StepBarProps {
  steps: Omit<StepIndicatorProps, 'active' | 'complete'>[];
  currentStep: number; // 0-based index
}

export const StepBar: React.FC<StepBarProps> = ({ steps, currentStep }) => (
  <div className="flex items-center gap-1">
    {steps.map((step, index) => (
      <React.Fragment key={step.number}>
        {index > 0 && <div className="w-8 h-px bg-border" />}
        <StepIndicator
          {...step}
          active={index === currentStep}
          complete={index < currentStep}
        />
      </React.Fragment>
    ))}
  </div>
);
